// copy of https://github.com/volkswagen-onehub/mofa/blob/9947b093b0af5c991d74c1d0b7a38617eb528231/packages/components/src/image-placeholder.tsx
import styled from 'styled-components';
import React from 'react';

export type ImagePlaceholderProps = React.PropsWithChildren<{
  readonly imageRatio: number;
  readonly placeholder?: React.ReactNode;
}>;

const StyledImagePlaceholder = styled.div<{imageRatio: number}>`
  position: relative;
  padding-top: ${(props) => (1 / props.imageRatio) * 100}%;
  overflow: hidden;
`;

const StyledImageWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;

export function ImagePlaceholder({
  imageRatio,
  children,
  placeholder,
}: ImagePlaceholderProps): JSX.Element {
  return (
    <StyledImagePlaceholder imageRatio={imageRatio}>
      {placeholder && <StyledImageWrapper>{placeholder}</StyledImageWrapper>}
      {React.Children.count(children) > 0 && (
        <StyledImageWrapper>{children}</StyledImageWrapper>
      )}
    </StyledImagePlaceholder>
  );
}
